<!--模版管理-->
<template>
    <div>
        <!--顶部搜索 按钮-->
        <el-row :gutter="20">
            <el-form  :size="size" label-width="100px">
                <el-col :span="3">
                    <el-input :size="size" placeholder="请输入产品名称" v-model="queryInfo.name" clearable ></el-input>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="产品分类：" >
                        <CategoryCascade :size="size" v-model="queryInfo.categoryId" @nodeChange="nodeCategoryCascader"></CategoryCascade>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-button :size="size" v-permission="['PRODUCT-MODEL-PAGE']" type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
                </el-col>
                <el-col :span="14" style="text-align: right;">
                    <el-button :size="size" v-permission="['PRODUCT-MODEL-SHORTCUT-ADD']" type="primary" icon="el-icon-plus" @click="showAddDialog">添加产品</el-button>
                </el-col>
            </el-form>
        </el-row>
        <!--内容展示-->
        <el-row style="margin-top: 2px;">
            <!--树形表格-->
            <!--<tree-table class="treetable" :max-height="treeTableHeight" :show-row-hover="true" border show-index index-text="#" :stripe="true" :data="tablelist" :columns="columns" :selection-type="false" :expand-type="false">
                <template slot="action" slot-scope="scope">
                    <el-button type="warning" size="mini" icon="el-icon-edit" round @click="showEditDialog(scope.row)">产品编辑</el-button>
                    <el-button v-if="scope.row.categoryId!==5" type="primary" size="mini" icon="el-icon-edit" round @click="showPEditDialog(scope.row)">p编辑</el-button>
                    <el-button v-if="scope.row.categoryId!==5" type="success" size="mini" icon="el-icon-edit" round @click="showP2EditDialog(scope.row)">p2编辑</el-button>
                    <el-button v-if="scope.row.categoryId!==5" type="info" size="mini" icon="el-icon-edit" round @click="showParamEditDialog(scope.row)">参数编辑</el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete" round @click="deleteEditDialog(scope.row)">删除</el-button>
                </template>
                <template slot="categoryId" slot-scope="scope">
                    <span>{{getParentNode(scope.row.categoryId).name}}</span>
                </template>
                <template slot="avatar" slot-scope="scope">
                    <img :src="getImg(scope.row)" class="avatar">
                </template>
            </tree-table>-->
            <el-table v-loading="loading" ref="tableRef" border stripe :height="treeTableHeight" :data="tablelist">
                <template v-for="(v,k) in columns">
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-if="v.label==='操作'">
                        <template slot-scope="scope">
                            <el-button v-permission="['PRODUCT-MODEL-UPDATE']" type="warning" size="mini" icon="el-icon-edit" round @click="showEditDialog(scope.row)">产品编辑</el-button>
                            <el-button v-permission="['PRODUCT-MODEL-PROJECT-UPDATE','PRODUCT-MODEL-PROJECT-QUERY']" v-if="scope.row.categoryId!==5" type="primary" size="mini" icon="el-icon-edit" round @click="showPEditDialog(scope.row)">p编辑</el-button>
                            <el-button v-permission="['PRODUCT-MODEL-PROJECT2-UPDATE','PRODUCT-MODEL-PROJECT2-QUERY']" v-if="scope.row.categoryId!==5" type="success" size="mini" icon="el-icon-edit" round @click="showP2EditDialog(scope.row)">p2编辑</el-button>
                            <el-button v-permission="['PRODUCT-MODEL-PARAM-UPDATE','PRODUCT-MODEL-PARAM-QUERY']" v-if="scope.row.categoryId!==5" type="info" size="mini" icon="el-icon-edit" round @click="showParamEditDialog(scope.row)">参数编辑</el-button>
                            <el-button v-permission="['PRODUCT-MODEL-DELETE']" type="danger" size="mini" icon="el-icon-delete" round @click="deleteEditDialog(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='categoryId'">
                        <template slot-scope="scope">
                            <span>{{getParentNode(scope.row.categoryId).name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='avatar'">
                        <template slot-scope="scope">
                            <img :src="getImg(scope.row)" class="avatar">
                        </template>
                    </el-table-column>
                    <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else></el-table-column>
                </template>
            </el-table>
            <!--分页区域-->
            <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
        </el-row>
        <div v-if="addDialogVisible">
            <el-dialog title="添加产品"
                       width="40%"
                       @close="handleClose"
                       :visible.sync="addDialogVisible"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :destroy-on-close="true">
                <el-steps :active="activeIndex - 0" finish-status="success" align-center>
                    <el-step title="基本信息" icon="el-icon-info"></el-step>
                    <el-step title="P2信息" icon="el-icon-info"></el-step>
                </el-steps>
                <el-form style="margin-top: 20px">
                    <el-tabs class="aaaa" :before-leave="beforeTabLeave" :tab-position="tabPosition"  v-model="activeIndex" @tab-click="tabClicked">
                        <el-tab-pane label="基本信息" name="0">
                            <PD ref="pdrefadd"></PD>
                        </el-tab-pane>
                        <el-tab-pane label="P2信息" name="1">
                            <P2 ref="p2refadd"></P2>
                        </el-tab-pane>
                    </el-tabs>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="addFun">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <div v-if="editDialogVisible">
            <el-dialog :title="titleForm"
                       width="40%"
                       @close="handleCloseEdit"
                       :visible.sync="editDialogVisible"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :destroy-on-close="true">
                <PD :item="editItem" ref="pdref" v-if="titleForm==='产品信息'"></PD>
                <PP :item="pItem" ref="pref" v-if="titleForm==='P信息'"></PP>
                <P2 :item="p2Item" ref="p2ref" v-if="titleForm==='P2信息'"></P2>
                <Param :item="paramItem" ref="paramref" v-if="titleForm==='参数信息'"></Param>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="editFun">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/pagination/index'
    import P2 from '@/components/product/P2'
    import PP from '@/components/product/P'
    import PD from '@/components/product/Product'
    import Param from '@/components/product/Param'
    import CategoryCascade from '@/components/category/Cascader'
    import {moduleProductPage, delModuleProduct, updateModuleProduct, categoryProductTree,
        saveProductAndProject2Together,
        updateP2, getP2,
        updateP, getP,
        getParam, updateParam} from '@/api/product'
    import { mapGetters } from 'vuex'
    export default {
        name: 'PRODUCT-MODEL',
        components: {
            Pagination, P2, PP, PD, Param, CategoryCascade
        },
        data() {
            return {
                tablelist: [],
                columns: [
                    {
                        label: '产品名称',
                        prop: 'name',
                        fixed: 'left',
                        width: '280px'
                    },{
                        label: '编码',
                        prop: 'code'
                    },{
                        label: '产品系列',
                        // type: 'template',
                        prop: 'categoryId'
                    },{
                        label: '产品图片',
                        // type: 'template',
                        prop: 'avatar'
                    },{
                        label: '创建时间',
                        prop: 'createTime'
                    },{
                        label: '操作',
                        // type: 'template',
                        prop: 'action',
                        width: '510px',
                        fixed: 'right'
                    }
                ],
                queryInfo: {
                    pagesize: 10,
                    pagenum: 1,
                    name: ''
                },
                total: 0,
                treeTableHeight: 650,
                editItem: {
                    name: '',
                    code: '',
                    categoryId: 1
                },
                editItemValid: false,
                titleForm: '添加产品',
                editDialogVisible: false,
                addDialogVisible:false,
                activeIndex: 0,
                p2Item: {
                    projectStruct: '',
                    protocol: '001 03 00 25',
                    t: '0 -1',
                    w: '0 -1',
                    f: '0 -1',
                    s1: '0 -1 0 -1',
                    s2: '0 -1 0',
                    s3: '0 -1 0',
                    s4: '1',
                    kzgt: '0 -1',
                    sign: 'mw 3 9705',
                    productId: '',
                    remark: ''
                },
                categoryTree: [],
                tabPosition: 'left',
                pItem: {},
                paramItem: {},
                size:this.COMMON.size,
                loading: true
            }
        },
        methods: {
            // 关闭添加
            handleClose() {
                this.$nextTick(() => {
                    this.activeIndex = 0
                })
                // this.$refs.editFormRef.resetFields()
                console.log('执行重置')
                this.addDialogVisible = false
            },
            handleCloseEdit(){
                if(this.titleForm==='产品信息'){
                    console.log('组件产品信息')
                    this.getModuleList()
                }else if(this.titleForm==='P信息'){
                    console.log('组件p信息')
                }else if(this.titleForm==='P2信息') {
                    // console.log('组件p2信息',this.$refs['p2ref'])
                    this.$refs['p2ref'].reset()
                }
                this.editDialogVisible = false
            },
            getModuleList() {
                if(this.queryInfo.name!=undefined) {
                    this.queryInfo.name = this.queryInfo.name.trim()
                }
                let param = {}
                param.current = this.queryInfo.pagenum
                param.size = this.queryInfo.pagesize
                this.loading = true
                moduleProductPage(param,this.queryInfo).then(response=>{
                    if(response.code!=200)
                        return this.$message.error('获取产品失败！')
                    console.log('获取产品分页结果',response)
                    this.tablelist = response.data.records
                    this.total = response.data.total
                    this.loading = false
                })
            },
            /**
             * 分页组件切换分页大小事件处理
             * @param newSize
             */
            handleSizeChange(newSize) {
                this.queryInfo.pagesize = newSize
                this.getModuleList()
            },
            /**
             * 分页组件切换页事件处理
             * @param newPage
             */
            handleCurrentChange(newPage) {
                this.queryInfo.pagenum = newPage
                this.getModuleList()
            },
            // 展示用户添加
            showAddDialog(){
                console.log('添加产品')
                this.titleForm = '添加产品'
                this.addDialogVisible = true
            },
            showEditDialog(item) {
                this.editItem = item
                console.log('要编辑产品信息',this.editItem)
                this.titleForm = '产品信息'
                this.editDialogVisible = true
            },
            async deleteEditDialog(item) {
                const confirmResult = await this.$confirm('此操作将删除该产品相关信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).catch(err => err)
                // 如果用户确认删除，则返回值未字符串 confirm
                // 如果用户取消了删除，则返回值未字符串 cancel
                if (confirmResult !== 'confirm') {
                    return this.$message.info('取消删除')
                }
                delModuleProduct(item.id).then(response => {
                    console.log('删除产品结果',response)
                    if(response.code!=200){
                        return this.$message.error(response.msg)
                    }
                    this.getModuleList()
                    this.$message.success(response.msg)
                })
            },
            addFun(){
                if(!this.$refs['p2refadd'].validateForm()) return
                if(!this.$refs['p2refadd'].check()) return
                let data ={
                    product: this.$refs['pdrefadd'].editItem,
                    project2: this.$refs['p2refadd'].p2Item
                }
                console.log('执行添加产品',data)
                saveProductAndProject2Together(data).then(response => {
                    if(response.code!=200){
                        return this.$message.error('添加产品失败！')
                    }
                    this.$message.success('添加产品成功！')
                    this.getModuleList()
                    this.addDialogVisible = false
                })
            },
            editFun(){
                if(this.titleForm==='产品信息'){
                    if(!this.$refs['pdref'].validateForm()) return
                    console.log('产品提交',this.$refs['pdref'].editItem)
                    updateModuleProduct(this.$refs['pdref'].editItem).then(response => {
                        console.log('编辑产品结果',response.code)
                        if(response.code!=200){
                            return this.$message.error('编辑产品失败！')
                        }
                        this.$message.success('编辑产品成功！')
                        this.getModuleList()
                        this.editDialogVisible = false
                    })
                }else if(this.titleForm==='P信息'){
                    if(!this.$refs['pref'].validateForm()) return
                    if(!this.$refs['pref'].check()) return
                    updateP(this.$refs['pref'].p2Item).then(response => {
                        console.log('编辑P结果',response.code)
                        if(response.code!=200){
                            return this.$message.error('编辑P失败！')
                        }
                        this.$message.success('编辑P成功！')
                        this.editDialogVisible = false
                    })
                }else if(this.titleForm==='P2信息'){
                    console.log('组件p2信息',this.$refs['p2ref'])
                    if(!this.$refs['p2ref'].validateForm()) return
                    if(!this.$refs['p2ref'].check()) return
                    updateP2(this.$refs['p2ref'].p2Item).then(response => {
                        console.log('编辑P2结果',response.code)
                        if(response.code!=200){
                            return this.$message.error('编辑P2失败！')
                        }
                        this.$message.success('编辑P2成功！')
                        this.editDialogVisible = false
                    })
                }else if(this.titleForm==='参数信息'){
                    if(!this.$refs['paramref'].validateForm()) return
                    updateParam(this.$refs['paramref'].editItem).then(response => {
                        console.log('编辑参数结果',response.code)
                        if(response.code!=200){
                            return this.$message.error('编辑参数失败！')
                        }
                        this.$message.success('编辑参数成功！')
                        this.editDialogVisible = false
                    })
                }

                // let data = JSON.parse(JSON.stringify(this.editItem))
                /*addModuleProduct(data).then(response => {
                    console.log('添加产品结果',response.code)
                    if(response.code!=200){
                        return this.$message.error('添加产品失败！')
                    }
                    // this.$message.success('添加产品成功！')
                    this.p2Item.productId = response.data.id
                    addP2(this.p2Item).then(response => {
                        if(response.code!=200){
                            return this.$message.error('添加解析配置失败！')
                        }
                        this.$message.success('添加产品成功！')
                        this.getModuleList()
                        this.editDialogVisible = false
                    })
                })*/
            },
            getHeight() {
                // console.log(window.innerHeight)
                this.treeTableHeight = window.innerHeight - 160 -55 -40 + 'px'
            },
            getCategoryTree(cb) {
                categoryProductTree({}).then(response=>{
                    if(response.code!=200)
                        return this.$message.error('获取产品分类树失败！')
                    //console.log('获取产品分类树结果',response)
                    this.categoryTree = response.data
                    return cb(this)
                })
            },
            async beforeTabLeave(activeName, oldActiveName) {
                if (oldActiveName === '0') {
                    return this.$refs['pdrefadd'].validateForm()
                }
            },
            tabClicked(tab) {
                console.log('选中tab项',tab.index )
                /*if(tab.index === '1'){
                    if(this.$refs['pdrefadd'].)
                    this.$message.error('信息未填全')
                    this.activeIndex = 0
                    return
                }*/
            },
            getParentNode(id) {
                // console.log('查找id',id,this.categoryTree)
                var hasFound = false, // 表示是否有找到id值
                    result = {name: ''}
                var fn = function (data) {
                    if (Array.isArray(data) && !hasFound) { // 判断是否是数组并且没有的情况下，
                        data.forEach(item => {
                            if (item.id === id) { // 数据循环每个子项，并且判断子项下边是否有id值
                                result = item // 返回的结果等于每一项
                                hasFound = true // 并且找到id值
                            } else if (item.child) {
                                fn(item.child) // 递归调用下边的子项
                            }
                        })
                    }
                }
                fn(this.categoryTree) // 调用一下
                // console.log('父节点',result.name,id)
                return result
            },
            showPEditDialog(item){
                this.titleForm='P信息'
                getP(item.id).then(response => {
                    if(response.code!=200){
                        return this.$message.error(response.msg)
                    }
                    this.pItem = response.data[0]
                    console.log('获取P信息',this.pItem)
                    this.editDialogVisible = true
                })
            },
            showP2EditDialog(item){
                this.titleForm='P2信息'
                getP2(item.id).then(response => {
                    if(response.code!=200){
                        return this.$message.error(response.msg)
                    }
                    this.p2Item = response.data
                    console.log('获取P2信息',this.p2Item)
                    this.editDialogVisible = true
                })
            },
            showParamEditDialog(item){
                this.titleForm='参数信息'
                getParam(item.id).then(response => {
                    if(response.code!=200){
                        return this.$message.error(response.msg)
                    }
                    this.paramItem = response.data
                    console.log('获取参数信息',this.paramItem)
                    this.editDialogVisible = true
                })
            },
            getImg(item){
                if(item.web){
                    return item.avatar
                }else if (item.avatar === 'undefined' || item.avatar === undefined || item.avatar === ''){
                    // console.log('this.avatar=' + this.avatar)
                    return require('@/assets/product/default.jpg')
                }
                return this.COMMON.httpUrl + '/static' + item.avatar + '?token=Bearer '+ this.token
            },
            nodeCategoryCascader(val){
                this.queryInfo.categoryId = val[val.length-1]
                console.log('选中产品id',this.queryInfo.categoryId)
            },
            /** 搜索按钮操作 */
            handleQuery() {
                this.queryInfo.pagenum=1
                this.getModuleList()
            }
        },
        computed: {
            ...mapGetters([
                'token'
            ])
        },
        created(){
            this.getHeight()
            window.addEventListener('resize', this.getHeight)
            this.getCategoryTree(function (e) {
                e.getModuleList()
            })
        },
        watch:{

        },
        activated(){
            this.$refs.tableRef.doLayout()
        }
    }
</script>

<style lang="scss" scoped>
.aaaa ::v-deep {
    .el-tab-pane {
        max-height: 500px !important;
        overflow-y: scroll !important;
    }
}
.avatar {
    height: 50px;
}
</style>
